module.exports = __webpack_public_path__ + "img/safety1.6d9a9eeb.png";